import { AuthError, PublicClientApplication } from "@azure/msal-browser";

import { msalConfig } from "./authConfig";

/**
 * Single shared MSAL instance so the React provider and the API token getter
 * agree on the same account/cache.
 */
export const msalInstance = new PublicClientApplication(msalConfig);

let msalInitialized = false;
let initializePromise: Promise<void> | null = null;

// Captured during handleRedirectPromise (e.g. invalid_client) so the login
// screen can surface the failure to the user.
let pendingAuthError: string | null = null;

export function setPendingAuthError(err: unknown): void {
  if (err instanceof AuthError) {
    pendingAuthError = err.errorMessage || err.message;
  } else if (err instanceof Error) {
    pendingAuthError = err.message;
  } else {
    pendingAuthError = String(err);
  }
}

export function getPendingAuthError(): string | null {
  return pendingAuthError;
}

export function clearPendingAuthError(): void {
  pendingAuthError = null;
}

/** Safe to call repeatedly; initializes MSAL exactly once. */
export async function ensureMsalInitialized(): Promise<void> {
  if (msalInitialized) return;
  if (!initializePromise) {
    // Reset on failure so a later call can retry instead of being stuck with a
    // permanently rejected promise (e.g. transient storage/config errors).
    initializePromise = msalInstance
      .initialize()
      .then(() => {
        msalInitialized = true;
      })
      .catch((error) => {
        initializePromise = null;
        throw error;
      });
  }
  await initializePromise;
}
